<template>
  <div>
    <v-footer class="justify-center" color="#292929" height="70" absolute>
      <div
        class="title font-weight-light grey--text text--lighten-1 text-center"
      >&copy; {{ (new Date()).getFullYear() }} — {{siteName}}, Created by Kenneth Adubobi [076 243 9441]</div>
    </v-footer>
  </div>
</template>

<script>
export default {
  data() {
    return {
      siteName: "BITSEMS"
    };
  }
};
</script>

<style>
</style>